import { Fragment } from "react"
import MainNavigation from "./MainNavigation";
import { useNavigate } from "react-router-dom";
import { useRouteError } from "react-router-dom";
import MainFooter from "./MainFooter";
import PageContent from "./Pages/PageContent";
const ErrorElement = () => {
  const navigate = useNavigate();
    const error = useRouteError();
    let title = 'Error occurred!';
    let message = 'Something went wrong!';
  
    if (error.status === 500) {
      message = error.data.message;
    }
  
    if (error.status === 404) {
      title = 'Not found!';
      message = "The Page you were trying to reach couldn't be found on the server";
    }
    if (error.status === 401) {
      navigate('/');
    }
  
    return (
        <Fragment>
         <MainNavigation />
            <PageContent title={title}>
            {message}
            </PageContent>
          <MainFooter />
        </Fragment>
    );

}
export default ErrorElement;